componentRegistryInstance.register('boolean', 'edit', 'hrd.components.form.BooleanComponent');
componentRegistryInstance.register('boolean', 'read', 'hrd.components.form.BooleanComponent');

hrd.components.form.BooleanComponent = hrd.components.AbstractFieldComponent.extend({
	init: function(options) {
		var defaults = {
			impl: 'hrd.components.form.BooleanComponent',
		};
		this._super($.extend(true, {}, defaults, options));
	},
	enhanceEditField: function(field, id, klass) {
		this._super(field, id, klass);
		var appearance = field.data('appearance') || 'minimal';
		if(appearance == 'minimal'){
			field.prop('type', 'checkbox'); // force to be a checkbox, if not already done in definition
			var defValue = field.data('default');
			if(defValue !== undefined){
				field.prop('checked', defValue);
			}
		} else if(appearance == 'full') {
			var emptyLabel = field.data('emptyLabel') != undefined ? field.data('emptyLabel') : xlate('keyword.boolean.all');
			var trueLabel  = field.data('trueLabel')  != undefined ? field.data('trueLabel')  : xlate('keyword.boolean.true');
			var falseLabel = field.data('falseLabel') != undefined ? field.data('falseLabel') : xlate('keyword.boolean.false');
			
			field.replaceElem('select');
			field = $('#' + id);
			if(emptyLabel != 'hidden'){
				field.addOption('', emptyLabel, false);
			}
			field.addOption('true', trueLabel, false);
			field.addOption('false', falseLabel, false);
			if(field.data('natural-size')){
				field.addClass('natural-size');
			}

			if(field.usingChromaFlow()) {
				$.timeout(0)
					.then(() => this.wrapForSelectAddon(field));
			}

			// needed because original element has changed
			return field;
		}
	},
	getEditableField: function(field, name, object, options) {
		var appearance = field.data('appearance') || 'minimal';
		if(appearance == 'full'){
			var b = (field.val() === 'true') ? true : (field.val() === 'false') ? false : null;
			this.setValueByPath(object, name, b);
		} else {
			this.setValueByPath(object, name, field.is(':checked'));
		}
	},
	getReadOnlyField: function(field, name, object, options) {
		var b = field.data('current-value');
		this.setValueByPath(object, name, b);
	},
	
	setEditableField: function(field, value, object, options) {
		var appearance = field.data('appearance') || 'minimal';
		if(appearance == 'full'){
			field.val("" + value);
		} else {
			field.prop('checked', value);
		}
	},
	setReadOnlyField: function(field, value, object, options) {
		const booleanTemplate = field.data('template');
		const template = '<span class="f-icon {icon}" style="color:{color};" title="{tooltip}"></span>';
		let b = $.isTrue(value);
		let html = hrd.utils.replaceParams(template, {
			icon: b ? 'f-icon far fa-check-square' : 'f-icon far fa-square',
			color: b ? 'green' : 'red',
			tooltip: b ? xlate('common.form.yes.label') : xlate('common.form.no.label')
		});
		
		field.attr('data-checked', !!b);
		
		if(booleanTemplate) {
			const isChecked = b ? 'checked' : '';
			html = `
				<div class="input-container ${booleanTemplate} read-only">
					<div class="boolean ${isChecked}"></div>
				</div>
			`;
			field.css({
				'line-height': 'normal',
				'height': 'auto'
			});
		}
		field.data('current-value', b);
		field.html(html);
	},

	initalizeComponent: function(field, initialValue) {
		this.log(`Component.initalizeComponent for "${this.settings.name} - ${this.settings.type} - ${this.settings.mode}"`, initialValue);
		var appearance = field.data('appearance') || 'minimal';
		if(appearance == 'full'){
			field.val("" + initialValue);
		} else {
			field.prop('checked', initialValue);
		}
	},
	resetEditableField: function(field, options) {
		var appearance = field.data('appearance') || 'minimal';
		if(appearance == 'full'){
			field.val(""); // default is empty
		} else {
			field.prop('checked', false);
		}
	},
	wrapForSelectAddon: function(field) {
		if(!field.usingChromaFlow()) return;

		let $addon = field.closest('.field-composite').find('[data-variants~="select-addon"]');
		if(!$addon.exists()) {
			// const offset = field.next() && field.next().exists() ? field.next().outerWidth(true) : 0;
			const offset = 0;
			field
				.after(`
					<button style="--offset: ${offset}px" data-variants="${field.parent().is('.field-composite-2x') ? 'large' : ''} icon select-addon" data-action="${field.data('name')}Addon" data-show-text="false" data-icon-primary="fas fa-chevron-down" ${field.data('reset') === 'exclude' ? 'data-reset="exclude"' : ''}>
					</button>
				`);
			$('[data-variants~="select-addon"]', field.closest('.field-composite'))
				.button()
				.button('option', 'icons', { primary: `f-icon fas fa-chevron-down` });

			$addon = field.closest('.field-composite').find('[data-variants~="select-addon"]');
		}

		if($addon.exists() && !$addon.closest('.select-addon-container').exists()) {
			$addon
				.add($addon.siblings(this.wrappableSelectors))
				.wrapAll('<div class="select-addon-container field-container"></div>');
		}
	}
});